import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { convertDate } from "utils/formatDate";
import { getDate } from "utils/formatDate";
import DateTimePicker from "../../../components/GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import { getListNguonVon, updateDataSearch } from "../../../actions/NguonVon";
import { useSelector, useDispatch } from "react-redux";
import { currentDate } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { formatDayMonth } from "utils/formatDate";
import NguonVonApi from "../../../service/nguonVonApi";
import { pushNotification } from "utils/notifications";

export const SuaLichSuGiaoDich = ({ customerId }) => {
  const dataSearch = useSelector((state) => state.dataSearchNguonVon);
  const dispatch = useDispatch();
  // console.log(user.combo);
  const initData = {
    thuchiId: 0,
    customerId: customerId,
    type: 0,
    thoigian: currentDate(),
    sotien: 0,
    ghichu: "",
  };
  const [dataLichSuNguonVon, setDataLichSuNguonVon] = useState({});

  const updateDropdown = (field) => (e) => {
    setDataLichSuNguonVon({
      ...dataLichSuNguonVon,
      [field]: e.target.value,
    });
  };

  //Set Data khi Update trường dữ liệu

  const onChangeSoTienVon = (e, index) => {
    const obj = { ...dataLichSuGiaoDich };
    obj.List[index].Value = convertToNumber(e.target.value);
    setDataLichSuGiaoDich(obj);
  };

  const onChangeThoiGian = (e, index) => {
    const obj = { ...dataLichSuGiaoDich };
    obj.List[index].Time = formatDayMonth(e);
    setDataLichSuGiaoDich(obj);
  };

  const onChangeGhiChu = (e, index) => {
    const obj = { ...dataLichSuGiaoDich };
    obj.List[index].Note = e.target.value;
    setDataLichSuGiaoDich(obj);
  };

  //list lịch sử giao dịch
  const searchInit = {
    customerId: customerId,
    pageIndex: 1,
    pageSize: 500,
  };
  const [dataSearchLichSuGiaoDich, UpdateDataSearchLichSuGiaoDich] =
    useState(searchInit);
  const dataInit = {
    List: [],
    TongBanGhi: 0,
    TongSoTienVon: 0,
  };
  const [dataLichSuGiaoDich, setDataLichSuGiaoDich] = useState(dataInit);

  useEffect(() => {
    if (customerId > 0) {
      NguonVonApi.lichSuNguonVon(
        dataSearchLichSuGiaoDich.customerId,
        dataSearchLichSuGiaoDich.pageIndex,
        dataSearchLichSuGiaoDich.pageSize
      ).then((response) => {
        setDataLichSuGiaoDich({
          ...dataLichSuGiaoDich,
          List: response.data.List,
          TongBanGhi: response.data.TongBanGhi,
          TongSoTienVon: response.data.TongSoTienVon,
        });
        // setDataLichSuNguonVon({
        //   ...dataLichSuNguonVon,
        //   thuchiId: dataComboUser1[0].thuchiId,
        //   customerId: customerId,
        //   type: dataComboUser1[0].type,
        //   thoigian: dataComboUser1[0].thoigian,
        //   sotien: dataComboUser1[0].sotien,
        //   ghichu: dataComboUser1[0].ghichu,
        // });
      });
    }
  }, []);

  const onSubmit = (index) => () => {
    NguonVonApi.editLichSuNguonVon(
      dataLichSuGiaoDich.List[index].ThuChiID,
      customerId,
      dataLichSuGiaoDich.List[index].Type,
      dataLichSuGiaoDich.List[index].Time,
      dataLichSuGiaoDich.List[index].Value,
      dataLichSuGiaoDich.List[index].Note
    ).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
        return;
      } else {
        // showAlert();
        pushNotification("Cập nhật thành công", "success", "TOP_CENTER", 1000);
        dispatch(getListNguonVon(dataSearch));
        return;
      }
    });
  };
  const listItem = () => {
    return (
      dataLichSuGiaoDich.List != null &&
      dataLichSuGiaoDich.List.map((item, index) => {
        const isNewest = index === 0 ? true : false;
        console.log(isNewest, "isNewest");
        // dataLichSuNguonVon.thuchiId = item.ThuChiID;
        // dataLichSuNguonVon.type = item.Type;
        // dataLichSuNguonVon.thoigian = item.CreatedTime;
        // dataLichSuNguonVon.sotien = item.Value;
        // dataLichSuNguonVon.ghichu = item.Note;
        // if (customerId > 0) {
        //   dataLichSuNguonVon.thuchiId = item.ThuChiID;
        //   dataLichSuNguonVon.type = item.Type;
        //   dataLichSuNguonVon.thoigian = item.CreatedTime;
        //   dataLichSuNguonVon.sotien = item.Value;
        //   dataLichSuNguonVon.ghichu = item.Note;
        // } else {
        //   dataLichSuNguonVon.thuchiId = 0;
        //   dataLichSuNguonVon.type = 0;
        //   dataLichSuNguonVon.thoigian = currentDate();
        //   dataLichSuNguonVon.sotien = 0;
        //   dataLichSuNguonVon.ghichu = "";
        // }
        return (
          <>
            <tr className="active">
              <td>{item.TypeName}</td>
              <td>
                <DateTimePicker
                  value={convertDate(item.Time)}
                  name="thoigian"
                  readOnly={!isNewest}
                  onChange={(e) => onChangeThoiGian(e, index)}
                ></DateTimePicker>
              </td>
              <td>
                <input
                  type="text"
                  id="projectinput2"
                  className="form-control input-sm"
                  placeholder=""
                  name="lname"
                  disabled
                  value={item.CreatedUser}
                />
              </td>
              <td>
                <input
                  type="text"
                  id="projectinput2"
                  className="form-control input-sm"
                  placeholder=""
                  name="lname"
                  value={formatNumber(item.Value)}
                  onChange={(e) => onChangeSoTienVon(e, index)}
                  disabled={!isNewest} // Vô hiệu hóa nếu không phải giao dịch mới nhất
                />
              </td>
              <td>
                <textarea
                  id="projectinput8"
                  rows="1"
                  className="form-control input-sm text-era"
                  name="comment"
                  placeholder="Ghi chú"
                  value={item.Note}
                  onChange={(e) => onChangeGhiChu(e, index)}
                  disabled={!isNewest} // Vô hiệu hóa nếu không phải giao dịch mới nhất
                ></textarea>
              </td>
              <td>
                <a
                  href={() => false}
                  className="blue btn-link"
                  hidden={!isNewest}
                  onClick={onSubmit(index)}
                >
                  <i className="la la-save"></i>
                </a>
              </td>
            </tr>
          </>
        );
      })
    );
  };

  return (
    <>
      <div className="card-header mt-2">
        <a className="card-title lead info collapsed">
          <h3>Lịch sử giao dịch</h3>
        </a>
      </div>
      <div className="card-collapse collapse show">
        <div className="card-content">
          <div className="card-body">
            <div className="table-responsive table-2">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Trạng thái</th>
                    <th className="width-200">Thời gian</th>
                    <th className="width-200">Nhân viên</th>
                    <th className="width-200">Số tiền vốn</th>
                    <th className="width-200">Ghi chú</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>{listItem()}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
